module.exports = __webpack_public_path__ + "img/login-copamtv.622a4a9c.svg";